import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LocationService } from '@kanzi-apes/kanzi-locations';
import {
  CustomerModel,
  LocationCreateModelFile,
  TypeLocationListModel,
  TypeLocationModel,
} from '@kanzi-apes/kanzi-models';
import { map, Observable } from 'rxjs';

@Component({
    selector: 'kanzi-apes-locations-file',
    templateUrl: './locations-file.component.html',
    styleUrls: ['./locations-file.component.scss'],
    standalone: false
})
export class LocationsFileComponent implements OnChanges {
  @Input() displayDialog: boolean;
  @Input() customer: CustomerModel | null;
  @Output() closeDialog  = new EventEmitter<boolean>();
  @Output() submitData = new EventEmitter<LocationCreateModelFile>();
  typeLocations$: Observable<TypeLocationModel[]> | null = null;

  formFileLocations: UntypedFormGroup = this.fb.group({
    master_file_location: [null, [Validators.required]],
    location_type_id: [null, [Validators.required]],
  });

  get master_file_location(){
    return this.formFileLocations.get('master_file_location');
  }
  get location_type_id(){
    return this.formFileLocations.get('location_type_id');
  }


  constructor(
    private fb: UntypedFormBuilder,
    private locationService: LocationService
  ) {
    this.displayDialog = false;
    this.customer = null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['displayDialog'] || changes['customer']) {
      // Handle input changes if needed
    }
  }

  error(req: string) {
    return (
      this.formFileLocations.controls[req].errors &&
      this.formFileLocations.controls[req].touched
    );
  }

  filterTypeLocations(event: any) {
    this.typeLocations$ = this.locationService
      .getlocationTypes({
        page: 1,
        page_size: 20,
        search: event.query,
      })
      .pipe(
        map((typelocations: TypeLocationListModel) => typelocations.results)
      );
  }


  upLoadFile() {
    this.submitData.emit({
      master_file_location:this.master_file_location?.value,
      location_type_id:this.location_type_id?.value.id,
      customer_id:this.customer?.id as number
    });
    this.close();
  }


  close() {
    this.formFileLocations.reset();
    this.closeDialog.emit(true);
  }

}
